import * as yup from "yup";

export const signUpSchema = yup.object().shape({
    firstname: yup.string().required('This is a required field'),
    lastname: yup.string().required('This is a required field'),
    email: yup.string().email('Enter a valid email address').required('Required'),
    password: yup.string().min(5).required('Required'), //Minimum of 5 characters
    confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Passwords must match').required('Required'),
    // stateOfOrigin: yup.string().min(1).required('Required'),
    // address: yup.string().required('Required')
});

export const signInSchema = yup.object().shape({
    email: yup.string().email().required('This field is required'),
    password: yup.string().min(5).required('This field is required')
});

export const resetPasswordSchema = yup.object().shape({
    email: yup.string().email().required('This field is required')
});

export const resetPasswordTokenSchema = yup.object().shape({
    password: yup.string().min(5).required('This field is required')
});

export const invoiceValidationSchema = yup.object({
    title: yup.string().required('Title is required'),
    description: yup.string().required('Description is required'),
    amount: yup.number()
        .typeError('Amount must be a number')
        .required('Amount is required'),
});

export const paymentValidationSchema = yup.object({
    type: yup.string().required('Type is required'),
    amount: yup.number()
        .typeError('Amount must be a number')
        .required('Amount is required'),
    ref: yup.string().optional()
});
